import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    soilTextures: [],
    soilTexturesOptions: [],
    selectedSoilTexture: undefined,
    crops: [],
    cropRotation: [],
    agriculturalPractice: [],
    agriculturalPracticeOptions: [],
    selectedSoilPreparation: [],
    cropRotationSelected: [],
};

export default createReducer(initial, {
    [actions.setSoilTextures]: (state, action) => {
        return { ...state, soilTextures: action.payload };
    },
    [actions.setSoilTexturesOptions]: (state, action) => {
        return { ...state, soilTexturesOptions: action.payload };
    },
    [actions.setSelectedSoilTexture]: (state, action) => {
        return { ...state, selectedSoilTexture: action.payload };
    },
    [actions.setCrops]: (state, action) => {
        return { ...state, crops: action.payload };
    },
    [actions.setCropRotation]: (state, action) => {
        return { ...state, cropRotation: action.payload };
    },
    [actions.setSelectedCropRotation]: (state, action) => {
        return { ...state, cropRotationSelected: action.payload };
    },
    [actions.setAgriculturalPractice]: (state, action) => {
        return { ...state, agriculturalPractice: action.payload };
    },
    [actions.setAgriculturalPracticeOptions]: (state, action) => {
        return { ...state, agriculturalPracticeOptions: action.payload };
    },
});
